/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {compilerService} from '../services/compiler.service';
import {dwService} from '../services/dw.service';

const directiveName = dwService.preference('carouselDirective');

/**
 * Carousel directive
 *
 * This is an adapter directive that will check and re-init with the actual carousel directive
 * used by the current project.
 */
export const carouselDirective = {
  /**
   * Carousel pre-defined options container
   */
  options: {},

  /**
   * Initialize plugin for the given element
   *
   * @param {Element} element Directive HTML element
   * @param {object}  options Directive options
   */
  init(element, options) {
    const attribute = element.getAttributeNode('amb-carousel');

    element.setAttribute(directiveName, attribute.value);
    element.removeAttribute(attribute.name);

    compilerService.compileElementByAttribute(element, element.getAttributeNode(directiveName));
  },

  /**
   * Destroy plugin for the given element
   *
   * @param {Element} element Directive HTML element
   */
  destroy(element) {
    // Do nothing...
  },
};
